import { render, staticRenderFns } from "./ModalityInputs.vue?vue&type=template&id=5c06884c&scoped=true&"
import script from "./ModalityInputs.vue?vue&type=script&lang=js&"
export * from "./ModalityInputs.vue?vue&type=script&lang=js&"
import style0 from "./ModalityInputs.vue?vue&type=style&index=0&id=5c06884c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c06884c",
  null
  
)

export default component.exports